const STYLE_ID = "ls-demo-timer-style";
const TIMER_ID = "ls-demo-timer";

const WARNING_MS = 5 * 60 * 1000;
const DANGER_MS = 60 * 1000;

const MARGIN = 8;

let timer = null;
let position = null;

const STYLE = `
    .ls-demo-timer {
        position: fixed;
        z-index: 10000;
        cursor: grab;
        touch-action: none;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 14px;
        border-radius: 999px;
        background: rgba(133, 92, 214, 0.95);
        color: #fff;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 13px;
        font-weight: 700;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        user-select: none;
        transition: background 0.3s ease;
    }
    .ls-demo-timer.is-dragging {
        cursor: grabbing;
        transition: none;
    }
    .ls-demo-timer.is-warning {
        background: rgba(255, 140, 26, 0.95);
    }
    .ls-demo-timer.is-danger {
        background: rgba(229, 62, 62, 0.95);
    }
    .ls-demo-timer svg {
        width: 15px;
        height: 15px;
        flex-shrink: 0;
    }
    .ls-demo-timer-label {
        font-weight: 600;
        opacity: 0.85;
    }
`;

const ICON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>`;

const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = STYLE;
    document.head.appendChild(style);
};

const formatRemaining = (ms) => {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;

    return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const place = (el) => {
    if (!position) return;

    position.left = clamp(
        position.left,
        MARGIN,
        window.innerWidth - el.offsetWidth - MARGIN,
    );
    position.top = clamp(
        position.top,
        MARGIN,
        window.innerHeight - el.offsetHeight - MARGIN,
    );

    el.style.left = `${position.left}px`;
    el.style.top = `${position.top}px`;
};

const pointFromEvent = (e) => {
    const t = e.touches?.[0] || e.changedTouches?.[0];
    return t ? { x: t.clientX, y: t.clientY } : { x: e.clientX, y: e.clientY };
};

const enableDrag = (el) => {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let originLeft = 0;
    let originTop = 0;

    const onMove = (e) => {
        if (!dragging) return;

        const p = pointFromEvent(e);
        position = {
            left: originLeft + (p.x - startX),
            top: originTop + (p.y - startY),
        };
        place(el);
        e.preventDefault?.();
    };

    const onEnd = () => {
        if (!dragging) return;
        dragging = false;
        el.classList.remove("is-dragging");
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onEnd);
        document.removeEventListener("touchmove", onMove);
        document.removeEventListener("touchend", onEnd);
        document.removeEventListener("touchcancel", onEnd);
    };

    const onStart = (e) => {
        const p = pointFromEvent(e);
        dragging = true;
        startX = p.x;
        startY = p.y;
        originLeft = position.left;
        originTop = position.top;

        el.classList.add("is-dragging");
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onEnd);
        document.addEventListener("touchmove", onMove, { passive: false });
        document.addEventListener("touchend", onEnd);
        document.addEventListener("touchcancel", onEnd);
        e.preventDefault?.();
    };

    el.addEventListener("mousedown", onStart);
    el.addEventListener("touchstart", onStart, { passive: false });
};

export const startDemoTimer = (expiresAt) => {
    if (!expiresAt || timer) return;

    ensureStyles();

    const el = document.createElement("div");
    el.id = TIMER_ID;
    el.className = "ls-demo-timer";
    el.title = "Esta sala es temporal y se borrará al acabar el tiempo";
    el.innerHTML = `
        ${ICON}
        <span class="ls-demo-timer-label">Sala temporal</span>
        <span class="ls-demo-timer-value"></span>
    `;
    document.body.appendChild(el);

    position = { left: window.innerWidth - el.offsetWidth - 16, top: 64 };
    place(el);
    enableDrag(el);
    window.addEventListener("resize", () => place(el));

    const value = el.querySelector(".ls-demo-timer-value");

    const tick = () => {
        const remaining = expiresAt - Date.now();

        value.textContent = formatRemaining(remaining);
        el.classList.toggle("is-warning", remaining <= WARNING_MS);
        el.classList.toggle("is-danger", remaining <= DANGER_MS);

        if (remaining <= 0) {
            clearInterval(timer);
            timer = null;
        }
    };

    tick();
    place(el);

    timer = setInterval(tick, 1000);
};

export const stopDemoTimer = () => {
    clearInterval(timer);
    timer = null;
    position = null;
    document.getElementById(TIMER_ID)?.remove();
};
